import { CUSTOMER_API_BASE_URL } from '../config/env';

export interface InsightItem {
  title: string;
  url: string;
  sourceName: string;
  sourceType: string;
  summary: string;
  contentType: string;
  relevanceScore: number;
}

export interface DiscoveredSource {
  name: string;
  url: string;
  platform: string;
  reason: string;
}

export interface CompetitorActivity {
  competitorName: string;
  activity: string;
  url?: string;
}

export interface DailyInsight {
  _id: string;
  date: string;
  sourcesChecked: number;
  itemsFound: number;
  topItems: InsightItem[];
  newSourcesDiscovered: DiscoveredSource[];
  competitorActivity: CompetitorActivity[];
  draftsGenerated: number;
  agentSummary: string;
  runCompletedAt?: string;
  runErrors: string[];
}

export interface BacklogItem {
  _id: string;
  sourceUrl: string;
  sourceTitle: string;
  sourceName: string;
  contentType: string;
  routingTarget: string;
  targetPlatform: string;
  assignedEngineerSlackId?: string;
  draftText: string;
  whyThisEngineer?: string;
  status: string;
  sentToEngineerAt?: string;
  createdAt: string;
}

export interface PendingSource {
  _id: string;
  name: string;
  type: string;
  query: string;
  notes?: string;
  createdAt: string;
}

export interface InsightsResponse {
  insight: DailyInsight | null;
  pendingSources: PendingSource[];
  recentBacklog: BacklogItem[];
}

export interface AllInsightsResponse {
  insights: DailyInsight[];
  pendingSources: PendingSource[];
}

export interface BacklogResponse {
  items: BacklogItem[];
}

async function get<T>(path: string): Promise<T> {
  const res = await fetch(`${CUSTOMER_API_BASE_URL}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json() as Promise<T>;
}

export const splatterboxService = {
  getAllInsights: (): Promise<AllInsightsResponse> =>
    get<AllInsightsResponse>('/api/splatterbox/insights/all'),

  getInsights: (date?: string): Promise<InsightsResponse> =>
    get<InsightsResponse>(date ? `/api/splatterbox/insights/${date}` : '/api/splatterbox/insights'),

  getBacklog: (status?: string): Promise<BacklogResponse> =>
    get<BacklogResponse>(status ? `/api/splatterbox/backlog?status=${status}` : '/api/splatterbox/backlog'),
};
